export const PageLoader = ({ loading }) => {
  if (!loading) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-[999]">
      <div className="flex w-full justify-center items-center space-x-2">
        <svg
          className="animate-spin"
          width="40"
          height="40"
          viewBox="0 0 1024 1024"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M899.367 511.532C899.367 725.721 725.732 899.356 511.542 899.356C297.353 899.356 123.718 725.721 123.718 511.532C123.718 297.342 297.353 123.707 511.542 123.707C725.732 123.707 899.367 297.342 899.367 511.532ZM241.684 511.532C241.684 660.57 362.504 781.39 511.542 781.39C660.581 781.39 781.401 660.57 781.401 511.532C781.401 362.493 660.581 241.673 511.542 241.673C362.504 241.673 241.684 362.493 241.684 511.532Z"
            fill="url(#paint0_linear_1093_9904)"
          />
          <path
            className=""
            d="M898.741 489.648C895.714 436.099 881.613 383.76 857.329 335.938C833.045 288.116 799.105 245.851 757.655 211.813C716.205 177.776 668.145 152.706 616.513 138.188C564.881 123.669 510.799 120.019 457.684 127.466L473.944 243.44C511.021 238.242 548.772 240.79 584.813 250.924C620.855 261.059 654.402 278.558 683.336 302.318C712.269 326.077 735.96 355.58 752.912 388.961C769.863 422.343 779.706 458.877 781.819 496.257L898.741 489.648Z"
            fill="#009BDE"
          />
          <defs>
            <linearGradient
              id="paint0_linear_1093_9904"
              x1="-635.906"
              y1="514.737"
              x2="899.367"
              y2="511.532"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#56CCFF" />
              <stop offset="1" stopColor="#CDF0FF" />
            </linearGradient>
          </defs>
        </svg>
      </div>
    </div>
  );
};
